import { FC } from "react";
import SmartSearchAndActionsLayout from "../../../components/Layouts/smart-search-and-actions-layout";
import { ActionButtonEnum } from "../../../enums/actionButtonEnum";
import { SearchOptionEnum } from "../../../enums/searchOptionEnum";
import { GetDeckStatusParams, getDeckStatus } from "../../../services/reports";
import { createIdFromSmartSearchParams } from "../../../utils/smartSearch";
import {ValidationEnum} from "../../../enums/validationEnum";

const ReportDeckStatus: FC = () => {
  return (
    <SmartSearchAndActionsLayout
      searchBy={[
        SearchOptionEnum.CHARITY,
        SearchOptionEnum.LOCATION,
      ]}
      actions={[
        ActionButtonEnum.REFRESH,
        ActionButtonEnum.SAVE_PDF,
        ActionButtonEnum.SAVE_CSV,
      ]}
      validations={[
          ValidationEnum.VALIDATE_SMART_SEARCH,
          ValidationEnum.VALIDATE_SEARCH,
      ]}
      validOnEmpty={false}
      onRefresh={(output, params) => {
        const getDeckStatusParams: GetDeckStatusParams = {
            name:"Deck Status",
            output,
        };

        if (params.id) {
          const id = createIdFromSmartSearchParams(params);
          getDeckStatusParams[id] = params.id;
        }

        return getDeckStatus(getDeckStatusParams);
      }}
    />
  );
};

export default ReportDeckStatus;
